import { shareReplay } from 'rxjs/operators';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class HartfordIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getHartfordIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.HARTFORD_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    /**
     * The integration status, fetched once and replayed to every later subscriber, so a page whose every
     * list row needs the status costs one request instead of one per row. A caller that has to observe a
     * status change made while the page is open reads getHartfordIntegrationStatus() directly.
     */
    getCachedHartfordIntegrationStatus() {
        if (!this.cachedIntegrationStatus$) {
            this.cachedIntegrationStatus$ = this.getHartfordIntegrationStatus().pipe(shareReplay(1));
        }
        return this.cachedIntegrationStatus$;
    }
    deactivateHartfordIntegration() {
        const url = this.urlsService.INTEGRATIONS.HARTFORD_INTEGRATION_AUTH;
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    getHartfordTerritories() {
        const url = this.urlsService.INTEGRATIONS.HARTFORD_TERRITORIES;
        return this.ajaxService.getDataObserveBody(url);
    }
    getHartfordClientSearchResults(searchTerms, page, ownerId) {
        let url = `${this.urlsService.INTEGRATIONS.HARTFORD_CLIENT_SEARCH}?searchTerms=${searchTerms}&page=${page}`;
        if (ownerId) {
            url += `&ownerId=${ownerId}`;
        }
        return this.ajaxService.getDataObserveBody(url);
    }
    getHartfordMatrixSearchResults(clientId, page) {
        const url = `${this.urlsService.INTEGRATIONS.HARTFORD_MATRIX_SEARCH}?clientId=${clientId}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importHartfordHoldings(postParams) {
        const url = this.urlsService.INTEGRATIONS.HARTFORD_IMPORT_HOLDINGS;
        return this.ajaxService.postJsonDataObserveBody(url, {
            ...postParams,
            ids: postParams.selectedMatrices.map((m) => m.id),
        });
    }
    postHartfordPushModel(modelPortfolioId, contactId, name) {
        const url = this.urlsService.INTEGRATIONS.HARTFORD_PUSH_MODEL;
        return this.ajaxService.postJsonDataObserveBody(url, {
            modelPortfolioId,
            contactId,
            name,
        });
    }
}
HartfordIntegrationService.ɵfac = function HartfordIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HartfordIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
HartfordIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HartfordIntegrationService, factory: HartfordIntegrationService.ɵfac, providedIn: 'root' });
